import { QueueTaskEmployeeItemModel } from './QueueTaskEmployeeItemModel';
import { QueueTaskPriorityItemModel } from './QueueTaskPriorityItemModel';
import { QueueTaskStatusItemModel } from './QueueTaskStatusItemModel';

/**
 * * Модель запроса на создание очереди задач
 */
export class ProjectQueueTaskCreateRequestModel {
  /**
   * * Номер группы
   */
  GroupId?: number;
  /**
   * * Номер рабочего пространства
   */
  NamespaceId?: string;
  /**
   * * Нахвание
   */
  Name!: string;
  /**
   * * Список сотрудников
   */
  Employees!: Array<QueueTaskEmployeeItemModel>;
  /**
   * * Список приоритетов
   */
  Priorities!: Array<QueueTaskPriorityItemModel>;
  /**
   * * Список статусов
   */
  Statuses!: Array<QueueTaskStatusItemModel>;
  constructor(obj?: Partial<ProjectQueueTaskCreateRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
